import type { CompetitorRow } from '@/lib/competitors.types'
import type { Competitor, Scores } from '@/lib/types'

const MAX_COMPETITORS = 30

export function normalizeBrandName(name: string): string {
  return name.trim().toLocaleLowerCase()
}

export function sameBrand(a: string, b: string): boolean {
  return normalizeBrandName(a) === normalizeBrandName(b)
}

// The backend counts brand and competitor mentions in the same unit, so the two rank together.
export function brandMentionCount(
  scores: Partial<Scores>,
  brand: string
): number | undefined {
  return scores.shareOfVoice?.find((entry) => sameBrand(entry.name, brand))
    ?.count
}

export function competitorRows(
  competitors: Competitor[],
  scores: Partial<Scores>,
  trackedBrand?: string
): CompetitorRow[] {
  const brand = trackedBrand?.trim()

  const rivals = competitors
    .filter((c) => brand === undefined || !sameBrand(c.name, brand))
    .slice(0, MAX_COMPETITORS)
    .map((c) => ({ name: c.name, count: c.count, isTrackedBrand: false }))

  if (brand === undefined || brand === '') return rivals

  const count = brandMentionCount(scores, brand)

  if (count === undefined) return rivals

  // A brand with no mentions and no rivals means nothing was detected at all.
  if (count === 0 && rivals.length === 0) return rivals

  return [...rivals, { name: brand, count, isTrackedBrand: true }].sort(
    (a, b) => b.count - a.count || a.name.localeCompare(b.name)
  )
}
